import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgShare(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M20.75 5.99599C20.75 3.64942 22.6544 1.75 25 1.75C27.3456 1.75 29.25 3.64942 29.25 5.99599C29.25 8.34256 27.3456 10.242 25 10.242C23.8604 10.242 22.825 9.79365 22.0615 9.06353L11.1594 15.1234C11.2188 15.4063 11.25 15.6995 11.25 16C11.25 16.3019 11.2185 16.5963 11.1586 16.8803L22.0608 22.9371C22.8244 22.2066 23.8601 21.7581 25 21.7581C27.3456 21.7581 29.25 23.6575 29.25 26.004C29.25 28.3506 27.3456 30.25 25 30.25C22.6544 30.25 20.75 28.3506 20.75 26.004C20.75 25.7009 20.7818 25.4051 20.8422 25.12L9.94193 19.0643C9.1781 19.7963 8.14128 20.246 7 20.246C4.65437 20.246 2.75 18.3466 2.75 16C2.75 13.6534 4.65437 11.754 7 11.754C8.14264 11.754 9.18058 12.2048 9.94466 12.9384L20.8424 6.8809C20.7819 6.5955 20.75 6.29949 20.75 5.99599ZM25 4.25C24.0319 4.25 23.25 5.03328 23.25 5.99599C23.25 6.9587 24.0319 7.74198 25 7.74198C25.9681 7.74198 26.75 6.9587 26.75 5.99599C26.75 5.03328 25.9681 4.25 25 4.25ZM7 14.254C6.03192 14.254 5.25 15.0373 5.25 16C5.25 16.9627 6.03192 17.746 7 17.746C7.96808 17.746 8.75 16.9627 8.75 16C8.75 15.0373 7.96808 14.254 7 14.254ZM23.25 26.004C23.25 25.0413 24.0319 24.2581 25 24.2581C25.9681 24.2581 26.75 25.0413 26.75 26.004C26.75 26.9668 25.9681 27.75 25 27.75C24.0319 27.75 23.25 26.9668 23.25 26.004Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgShare);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
